// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'pipeline-solid';

export const Component = () => (
  <path d='M24.521 6.89V1H0v5.89h24.521ZM21.6 15.703V9.86H2.922v5.843H21.6Zm-2.97 8.86v-5.89H5.891v5.89h12.74Z' />
);

export const viewBox = '0 0 25 25';
